"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var RadioButton_st_css_1 = require("./RadioButton.st.css");
var filter_data_props_1 = require("../../utils/filter-data-props");
var noop = function () { return null; };
var RadioButton = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButton, _super);
    function RadioButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focusedByMouse = false;
        _this.state = {
            focused: false,
            focusVisible: false,
        };
        _this.handleClick = function (event) {
            _this.focusedByMouse = true;
            _this.handleInputChange(event);
        };
        _this.handleInputChange = function (event) {
            if (!_this.props.disabled) {
                _this.props.onChange(tslib_1.__assign({ value: _this.props.value }, event));
                if (_this.radioRef) {
                    _this.radioRef.focus();
                }
            }
        };
        _this.onHover = function (event) {
            _this.props.onHover(tslib_1.__assign({ value: _this.props.value }, event));
        };
        _this.onFocus = function () {
            _this.setState({ focused: true, focusVisible: !_this.focusedByMouse });
        };
        _this.onInputBlur = function () {
            _this.setState({ focused: false, focusVisible: false });
            _this.focusedByMouse = false;
        };
        _this.handleInputKeyDown = function (event) {
            _this.setState({ focusVisible: true });
            if (!_this.props.disabled) {
                _this.props.onKeyDown(tslib_1.__assign({ value: _this.props.value }, event));
            }
        };
        _this.radioRef = undefined;
        return _this;
    }
    RadioButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, name = _a.name, checkedIcon = _a.checkedIcon, uncheckedIcon = _a.uncheckedIcon, label = _a.label, checked = _a.checked, disabled = _a.disabled, required = _a.required, onIconBlur = _a.onIconBlur, tabIndex = _a.tabIndex, className = _a.className;
        var focused = this.state.focused;
        return (React.createElement("div", tslib_1.__assign({ className: RadioButton_st_css_1.st(RadioButton_st_css_1.classes.root, {
                checked: checked,
                disabled: disabled,
                focused: focused,
                'focus-visible': this.state.focusVisible,
            }, className), onChange: this.handleInputChange, onClick: this.handleClick, role: "radio", "aria-checked": checked ? checked : false }, filter_data_props_1.filterDataProps(this.props)),
            React.createElement("input", { type: "radio", className: RadioButton_st_css_1.classes.hiddenRadio, disabled: disabled, required: required, onFocus: this.onFocus, onBlur: this.onInputBlur, checked: checked, value: value, name: name, tabIndex: tabIndex, onChange: function () { return null; }, onKeyDown: this.handleInputKeyDown, ref: function (radio) { return (_this.radioRef = radio); }, "aria-label": this.props['aria-label'] }),
            React.createElement("span", { className: RadioButton_st_css_1.classes.icon, onMouseEnter: this.onHover, onMouseLeave: onIconBlur }, checked ? checkedIcon : uncheckedIcon),
            React.createElement("span", { className: RadioButton_st_css_1.classes.label }, label)));
    };
    RadioButton.displayName = 'RadioButton';
    RadioButton.defaultProps = {
        onChange: noop,
        onKeyDown: noop,
        onHover: noop,
        onBlur: noop,
    };
    return RadioButton;
}(React.Component));
exports.RadioButton = RadioButton;
//# sourceMappingURL=RadioButton.js.map